import { http } from '@/lib/http';
import type { ReconciliationReport } from './types';

// operator-bff:GET /v1/disruptions/{urn}/reconciliation@v2 (#807; prices only, M3) +
// the `.csv` twin (Excel-ready: UTF-8 BOM, `;` separator, Spanish «Precio …» headers).

const base = (urn: string) => `v1/disruptions/${encodeURIComponent(urn)}/reconciliation`;

export async function fetchReconciliation(urn: string): Promise<ReconciliationReport> {
  return http.get(base(urn)).json<ReconciliationReport>();
}

/** The CSV as a blob plus the filename the BFF stamped (disruption + generation time). */
export async function fetchReconciliationCsv(urn: string): Promise<{ blob: Blob; filename: string }> {
  const res = await http.get(`${base(urn)}.csv`);
  const disposition = res.headers.get('content-disposition') ?? '';
  const match = /filename="([^"]+)"/.exec(disposition);
  return { blob: await res.blob(), filename: match?.[1] ?? 'conciliacion.csv' };
}

/** Browser download of a fetched file — one object URL, revoked after the click. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}
